import json from "@/data/copy/home-page.json";
import { createCopyGetter } from "./localize-copy";

export const getHomePageCopy = /*#__PURE__*/ createCopyGetter(json);
